// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".occupied[data-v-6104e666] {\n  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));\n  --tw-bg-opacity: 0.5;\n  z-index: 2;\n  pointer-events: none\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
